import { ExportOfferRequestParams } from '../api';

export const SEU_LANGUAGE_DEFAULT: SeuLanguage = 'DE';

export type SeuLanguage = Required<ExportOfferRequestParams>['language'];

export const SEU_LANGUAGES: SeuLanguage[] = ['DE', 'EN'];
